module.exports = __webpack_public_path__ + "static/img/1.c721c7d5.png";